import { useEffect, useState, useRef } from "react";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
 faAngleUp
} from "@fortawesome/pro-solid-svg-icons";
import {
  faFacebook,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemes } from "./context/MemesContext";
// import useOnScreen from "../../shared/hooks/useOnScreen";
// import { toAssetUrl } from "../../shared/common";
import { Link } from "react-router-dom";

const MemesIndex = () => {
  const { memes, getMemes } = useMemes();
  const [page, setPage] = useState(1)
  const [containerHeight, setContainerHeight] = useState(0)
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef<HTMLInputElement | null>(null);;

 // on page count update fetch more memes
  useEffect(() => {
    setLoading(true);
    getMemes(page);
    setLoading(false);
  }, [page]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const firstEntry = entries[0];
        if (firstEntry.isIntersecting && !loading) {
          console.log('new page')
          setPage((prevPage) => prevPage + 1);
        }
      },
      {
        rootMargin: "1500px",
        threshold: 0
      }
    );

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      if (bottomRef.current) {
        observer.unobserve(bottomRef.current);
      }
    };
  }, [loading]);

  useEffect(() => {
    document.body.classList.add("fixed-nav");
    return () => {
      document.body.classList.remove("fixed-nav");
    };
  }, []);


  // this takes the height of the .memes-wrapper element and uses it to set the same height
  // of the meme-mobile-container element
  const elem = document.querySelector('.meme-wrapper') as HTMLElement | null;
  if (elem != null && containerHeight == 0) {
    setContainerHeight(elem.offsetHeight + 2)
  }

  console.log(page, 'page')
  return (
    <>
      <div className="show-for-small-only snap-section" id="memes-splash">
        <div id="meme-spalsh--middle">
          <div id="middle-content" className="text-center">
            <h1 className="primary-font-color" id="generator-heading"><span>#</span>ИнтернетЗвезда</h1>
            <p>Помогни повече котета да намерят дом, като създаваш и споделеш забавни мемета. Всяко меме използва снимка на коте, което търси дом. Когато участваш активно, ти помагаш обявите да стигнат до повече хора.</p>
            <br/>
            <FontAwesomeIcon icon={faAngleUp as IconProp} className="swipe-icon fa-beat" />
            <div id="meme-spalsh--bottom--text" className="global-weight-bold">Слайп нагоре</div>            
          </div>
        </div>
      </div>
      <div className="snap-section">
        <div className="grid-container">
          <div className="grid-x grid-margin-x align-top">
            <div className="cell medium-3 hide-for-small-only">
              <div style={{position: 'fixed', width: 'inherit', padding: '0 10px'}}>
                <p>Purrs помага на бездомни котета да намерят грижовни стопани. Създавайки и споделяйки миймове помагаш повече от котетата ни да намерят домове.</p>
                <h3>Последвай ни</h3>
                <p>
                  <a className="global-weight-bold" href="https://www.instagram.com/fun.purrs.bg">
                    <FontAwesomeIcon icon={faInstagram as IconProp} className="follow-icon ig" />
                    &nbsp;
                    @fun.purrs.bg
                  </a>
                </p>
                <p>
                  <a className="global-weight-bold" href="https://www.instagram.com/purrs.bg/">
                    <FontAwesomeIcon icon={faInstagram as IconProp} className="follow-icon ig" />
                    &nbsp;
                    @purrs.bg
                  </a>
                </p>
                <p>
                  <a className="global-weight-bold" href="https://www.facebook.com/purrs.bg">
                    <FontAwesomeIcon icon={faFacebook as IconProp} className="follow-icon fb" />
                    &nbsp;
                    fb.com/purrs.bg
                  </a>
                </p>
              </div>
            </div>
            <div className="cell medium-5">
              <div id="memes-container" className="meme-mobile-container" style={{height: containerHeight}}>
                {memes.map((meme) => (
                  <MemeItem key={meme.identifier} meme={meme} />
                ))}
                <div style={{textAlign: 'center', padding: '20px'}} ref={bottomRef}>
                  <div className="clock-loader" style={{margin: 'auto'}}></div>
                </div>
              </div>
            </div>

            <div className="cell medium-4 hide-for-small-only">
              <div style={{position: 'fixed', width: 'inherit', padding: '0 30px'}}>
                <div className="callout primary text-center">
                  <h3 className="color-white">Осинови коте</h3>
                  <p className="color-white">Намери и осинови пухкав приятел, който ще донесе щастие и комфорт в дома ти.</p>

                  <a href="/" className="button block large border-white">Осинови</a>
                </div>
                <br/>
                <div className="callout secondary text-center">
                  <h3 className="color-white">Намери дом</h3>
                    <p className="color-white">Намериш дом и добри стопани за бездомно коте като го публикуваш в Purrs.</p>
                    <a href="/" className="button secondary block large border-white">Осинови</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const MemeItem = (props: any) => {
  const { meme } = props;
  return (
    <div className="meme-wrapper">
      <div className="meme-content">
        <div className="meme-item" style={{backgroundImage: `url(${meme.image_url})`}}></div>
        <div className="grid-x grid-margin-x align-middle meme-footer">
          <div className="cell medium-6 small-6">
            <Link to={meme.identifier} className="button wide secondary color-white no-margin">Сподели</Link>
          </div>
          <div className="cell medium-6 small-6 text-right">
          {meme.kitten.state == 'published' ? (
            <a href={`${process.env.REACT_APP_PURRS_API_HOST}/kittens/${meme.kitten.identifier}`} className="button wide no-margin">Осинови</a>
            ) : ""
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default MemesIndex;